module.exports = __webpack_public_path__ + "img/shortcut_chat_off.8a3d35e1.svg";